var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container h-flex-center h-mt-40 h-fw-500"},[_vm._v(" AppointmentPartnerCompany ")])
}
var staticRenderFns = []

export { render, staticRenderFns }